<template>
  <div class="table-group">
    <div class="group-title flex flex-x-between flex-y-center">
      <span>零件材料成本</span>
      <!-- 分切/尾料统计（参考小程序材料分析报告） -->
      <div v-if="tailStats" class="tail-stats">
        <span class="stats-item c-green">单{{ mainData.unit || '单位' }}可分切 {{ tailStats.singleCount }} 件</span>
        <span class="stats-item">尾料长度：<span class="c-blue">{{ tailStats.lengthText }}</span></span>
        <span class="stats-item">尾料总长度：<span class="c-blue">{{ tailStats.totalLengthText }}</span></span>
        <span class="stats-item">尾料重量：<span class="c-blue">{{ tailStats.weight }} kg</span></span>
        <span class="stats-item">尾料总重量：<span class="c-blue">{{ tailStats.totalWeight }} kg</span></span>
      </div>
    </div>
    <vxe-grid
      :min-height="tableConfig.minHeight"
      :toolbar-config="tableConfig.toolbarConfig"
      :edit-config="tableConfig.editConfig"
      :row-config="tableConfig.rowConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="selfList"
      :show-footer="!!selfList.length"
    >
      <!-- slot_default -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image
          v-if="row.list_chan_pin_tu"
          :list.sync="row.list_chan_pin_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_name="{ row }">
        <div class="flex flex-x-between flex-y-center">
          <el-input v-model="row.name" size="mini" class="flex-1" :disabled="disabled" />
        </div>
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image
          :list.sync="row.list_gong_cheng_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" :disabled="disabled" isDelete />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>
      <template #default_do="{ rowIndex }">
        <el-link type="danger" :disabled="disabled" @click="rowDelete(rowIndex)"> 删行 </el-link>
      </template>

      <!-- slot_edit -->
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" type="text" size="mini" @input="inputUpdate('spec', row)" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" type="text" size="mini" @input="inputUpdate('unit', row)" />
      </template>
      <template #edit_counts="{ row }">
        <el-input
          v-model="row.counts"
          type="number"
          size="mini"
          @input="inputUpdate('counts', row)"
        />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input
          v-model="row.goods_price"
          type="number"
          size="mini"
          @input="onGoodsPriceInput(row)"
        />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" type="text" size="mini" />
      </template>

      <!-- 数据为空 -->
      <template #empty>
        <div class="flex flex-center">
          <span class="c-gray-light">暂无数据</span>
          <el-link v-if="!disabled" class="m-l-10" type="success" @click="rowAdd">增行</el-link>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    mainData: {
      type: Object,
      required: true
    },
    goods_price: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      jin_du_list: ['待采购', '采购中', '已入库'],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 103
        },
        {
          title: '零件图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '零件名称',
          field: 'name',
          slots: { default: 'default_name' },
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' },
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' },
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' },
          width: 120
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ],
      selfList: [],
      singleCount: 1,
      isEditingPrice: false,
      productDetail: null
    }
  },
  computed: {
    // 手动模式：任一零件规格含闭合括号，自动互算不准确，禁止与原料相互估算
    isManual() {
      return this.selfList.some((row) => this.$tool.hasBracket(row.spec))
    },
    // 支重：复用商品模板公式（重量组主单位换算值），与小程序材料分析口径一致
    unitWeight() {
      let { spec, ji_chu_jia_ge: basePrice } = this.mainData
      let detail = this.productDetail
      if (!detail || !spec || this.$tool.hasBracket(spec)) return ''
      let data = this.$util.deepCopy(detail)
      // 附加参数示例缺失时取模板配置默认值
      let fuJiaList = data.fu_jia_can_shu_list || []
      data.fu_jia_can_shu_shi_li = fuJiaList.map((item, index) => {
        return (data.fu_jia_can_shu_shi_li || [])[index] || item.value || ''
      })
      this.$tool.actionVerify(
        {
          gui_ge_shi_li: spec,
          ji_chu_jia_ge: Number(basePrice) || Number(data.ji_chu_jia_ge) || 0,
          ji_chu_chan_liang: data.ji_chu_chan_liang || 1
        },
        data
      )
      // 支重 = 重量组主单位换算值
      let weight = ''
      ;(data.dan_wei_zu_list || []).forEach((itemSt) => {
        if (itemSt.dan_wei_zu_name !== '重量') return
        ;(itemSt.dan_wei_list || []).forEach((itemNd) => {
          if (itemNd.is_zhu_ji_liang && itemNd.verify_unit_val !== '') {
            weight = Number(itemNd.verify_unit_val)
          }
        })
      })
      return weight
    },
    // 分切/尾料统计：原料或零件规格无效时不展示
    tailStats() {
      let raw = this.mainData
      let part = this.selfList[0]
      if (!raw || !part || !raw.spec || !part.spec || !Number(raw.counts)) return null
      if (this.$tool.hasBracket(raw.spec) || this.$tool.hasBracket(part.spec)) return null
      let rawArr = String(raw.spec).split('*').map(Number)
      let partArr = String(part.spec).split('*').map(Number)
      if (rawArr.some((n) => !Number.isFinite(n) || !n) || partArr.some((n) => !Number.isFinite(n) || !n)) {
        return null
      }
      // 单单位可分切件数
      let singleCount = Number(this.$tool.getSinglePartCount(raw.spec, part.spec)) || 0
      // 管/棒/柱类（两规格排序后仅一个维度不同）才有长度尾料，板类显示 '-'
      let rawSort = rawArr.slice().sort((a, b) => b - a)
      let partSort = partArr.slice().sort((a, b) => b - a)
      let notSameCount =
        rawSort.length === partSort.length
          ? rawSort.filter((n, i) => n !== partSort[i]).length
          : 0
      let isPipe = notSameCount === 1
      let materialLength = rawArr[rawArr.length - 1]
      let partLength = partArr[partArr.length - 1]
      let tailingLength = 0
      if (isPipe && materialLength && partLength) {
        // 整数运算避免浮点误差，再收敛到 4 位消除取模残留的长尾小数
        tailingLength = this.$XEUtils.round(((materialLength * 10000) % (partLength * 10000)) / 10000, 4)
      }
      let tailingTotalLength = this.$XEUtils.round(
        this.$XEUtils.multiply(tailingLength, Number(raw.counts)),
        2
      )
      // 尾料重量 = 支重 × (1 - 利用率)，利用率 = 实际可切数量 / 理论可切数量
      let tailingWeight = null
      let tailingTotalWeight = null
      let weight = this.unitWeight
      let materialProduct = rawArr.reduce((acc, val) => this.$XEUtils.multiply(acc, val), 1)
      let partProduct = partArr.reduce((acc, val) => this.$XEUtils.multiply(acc, val), 1)
      if (weight !== '' && materialProduct > 0 && partProduct > 0 && singleCount > 0) {
        let theoreticalCount = this.$XEUtils.divide(materialProduct, partProduct)
        let utilization = this.$XEUtils.divide(singleCount, theoreticalCount)
        // 利用率除不尽时先收敛精度，再向上取 4 位，避免展示过长小数
        utilization = this.$XEUtils.round(utilization, 6)
        tailingWeight = Math.max(0, this.$XEUtils.multiply(weight, this.$XEUtils.subtract(1, utilization)))
        tailingTotalWeight = Math.max(0, this.$XEUtils.multiply(tailingWeight, Number(raw.counts)))
      }
      // 统一格式化：getPoint 按方向取位后，再用 round 收敛除不尽时的浮点长尾（如 0.30000000000000004），输出不超位且无多余 0
      const fmt = (val, digits, type) => {
        if (val === null) return '-'
        let point = this.$util.getPoint(val, type, digits)
        return String(this.$XEUtils.round(point, digits))
      }
      let lengthText = isPipe ? `${fmt(tailingLength, 2, 'down')} mm` : '-'
      let totalLengthText = isPipe ? `${fmt(tailingTotalLength, 2, 'down')} mm` : '-'
      return {
        singleCount,
        lengthText,
        totalLengthText,
        weight: `${fmt(tailingWeight, 4, 'up')}${tailingWeight === null ? '' : ' kg'}`,
        totalWeight: `${fmt(tailingTotalWeight, 4, 'up')}${tailingTotalWeight === null ? '' : ' kg'}`
      }
    },
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    'mainData.bind_id': {
      handler(val) {
        if (val) this.loadProductDetail(val)
      },
      immediate: true
    },
    list: {
      handler(val) {
        if (this.isEditingPrice) return
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        // 注意：此处不能被 isEditingPrice 拦截，否则手动修改零件单价时无法同步到父组件，
        // 会导致成本核算报告单价不更新、且修改后的单价在其它操作后被旧值还原
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', this.$util.deepCopy(val))
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取原料商品模板详情（用于支重公式计算）
    async loadProductDetail(id) {
      if (this.productDetail && this.productDetail.id === id) return
      this.productDetail = null
      let result = null
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/products/detail',
        params: { id }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            result = this.$util.deepCopy(res.data.data)
          }
        })
        .catch(() => {})
      // 异步回来校验，避免旧请求覆盖新原料
      if (result && result.id === this.mainData.bind_id) {
        this.productDetail = result
      }
    },
    // 行-增行
    rowAdd() {
      let result = this.$util.deepCopy(this.$constant.newTableSaleSubObj)
      result.name = this.mainData.name
      result.spec = this.mainData.spec
      result.counts = this.mainData.counts
      result.unit = this.mainData.unit
      result.goods_price = this.mainData.goods_price
      result.goods_amount = this.mainData.goods_amount
      this.selfList.push(result)
    },
    // 行-删行
    rowDelete(index) {
      this.selfList.splice(index, 1)
      this.$emit('delete')
    },
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    inputUpdate(field, row) {
      let obj = {
        idx: 2,
        key: field,
        val: row[field]
      }
      if (field === 'spec') {
        if (this.isManual) {
          // 规格含括号：不用原料数据反算零件数量/单价，仅重算本行金额（单价×数量）
          row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
          // 零件规格变更：将工艺列表、成本核算报告的规格同步为零件规格
          this.$emit('fieldUpdate', this.$util.deepCopy({ idx: 2, key: 'spec', val: row.spec }))
        } else {
          let counts = this.$tool.getSinglePartCount(this.mainData.spec, row.spec)
          this.singleCount = counts
          row.counts = this.$XEUtils.multiply(this.mainData.counts, counts)
          let goods_price = this.$XEUtils.divide(this.mainData.goods_price, counts)
          row.goods_price = this.$XEUtils.round(goods_price, 4)
          row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
          // 零件规格变更：将工艺列表、成本核算报告的规格同步为零件规格
          this.$emit('fieldUpdate', this.$util.deepCopy({ idx: 2, key: 'spec', val: row.spec }))
          // 向下游发出 counts 级联
          obj.key = 'counts'
          obj.val = row.counts
        }
      }
      if (field === 'counts') {
        if (this.isManual) {
          // 规格含括号：不回写原料数量、不反算零件单价，本行金额 = 单价×数量 自重算
          row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
        } else {
          // 根据当前规格实时计算单件系数，避免使用未编辑规格时的默认值(1)导致原材料数量算错
          let singleCount = this.$tool.getSinglePartCount(this.mainData.spec, row.spec)
          this.singleCount = singleCount
          let data = this.$util.deepCopy(this.mainData)
          let result = this.$XEUtils.divide(row.counts, singleCount)
          data.counts = this.$XEUtils.ceil(result)
          this.$emit('update:mainData', data)
          // 延迟等待 mainData 更新后重算单价
          setTimeout(() => {
            let goods_price = this.$XEUtils.divide(this.mainData.goods_amount, row.counts)
            row.goods_price = this.$XEUtils.round(goods_price, 4)
            row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
          }, 100)
        }
      }
      this.$emit('fieldUpdate', this.$util.deepCopy(obj))
    },
    // 手动修改零件单价时，重算金额并通知父组件反向更新原材料
    onGoodsPriceInput(row) {
      this.isEditingPrice = true
      row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
      if (this.isManual) {
        // 规格含括号：不反向估算原材料单价/金额，仅保留本行金额自重算
        this.$nextTick(() => {
          this.isEditingPrice = false
        })
        return
      }
      // 计算所有零件的总金额，直接传给父组件避免父组件读取旧数据
      let totalPartsAmount = 0
      this.selfList.forEach((item) => {
        totalPartsAmount = this.$XEUtils.add(totalPartsAmount, Number(item.goods_amount))
      })
      this.$nextTick(() => {
        this.$emit('partPriceChange', { totalPartsAmount })
        this.$nextTick(() => {
          this.isEditingPrice = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
}
.tail-stats {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: normal;
  .stats-item {
    margin-left: 18px;
    white-space: nowrap;
  }
}
</style>
